import './App.css';
import { RenderRout } from './router';
import { NotificationProvider } from './NotificationContext';

function App() {
  return (
    <div className="App">
      <NotificationProvider>
        <RenderRout />
      </NotificationProvider>
    </div>
  );
}

export default App;